<template>
  <template v-if="successItems.length > 0">
    <div class="images-grid" :class="{
      detailed: detailed
    }">
      <template v-if="imageDimensions">
          <template
            v-for="image, i in images"
            :key="i"
          >
            <ImageGridItem
              :image="image"
              :label="label"
              :successTag="successTag"
              :baseImageUrl="baseImageUrl"
              :detailed="detailed"
              :detailKeys="detailKeys"
              :imageDimensions="imageDimensions"
            />
          </template>
      </template>
    </div>
  </template>
  <template v-else>
    <div class="empty">
      <h2>검출된 결과가 없습니다.</h2>
      <ul>
        <li>- 현재 지원하지 않는 객체일 수 있습니다.</li>
        <li>- 이미지 내 검출 대상이 잘 보이는지 확인해 주세요.</li>
        <li>- 다른 이미지를 선택해 보세요.</li>
        <li>- 검출하려는 대상과 기술이 일치한지 확인해 주세요.</li>
      </ul>
    </div>
  </template>
</template>


<script>
import ImageGridItem from './ImageGridItem'


export default {
  props: {
    detailed: {
      type: Boolean,
      default: false
    },
    baseImageUrl: String,
    images: Array,
    label: {
      type: String,
      default: "Item"
    },
    successTag: {
      type: String,
      default: 'success'
    },
    showFailOnNonSuccess: {
      type: Boolean,
      default: false
    },
    imageDimensions: [Object, Boolean],
    detailKeys: [Object, Array]
  },
  computed: {
    successItems() {
      if (this.showFailOnNonSuccess) {
        return this.images.filter(image=> image[this.successTag])
      }
      return this.images
    }
  },
  components: {
    ImageGridItem
  }
}

</script>

<style lang="scss" scoped>

.images-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  &.detailed {
    grid-template-columns: repeat(2, 1fr);
  }
}


.empty {
  --empty-title-font-size: 20px;
  --empty-list-font-size: 16px;
  --empty-margin-size: 12px;
  @media screen and (max-width: 940px) {
    --empty-title-font-size: 18px;
    --empty-list-font-size: 14px;
    --empty-margin-size: 8px;
  }
  @media screen and (max-width: 640px) {
    --empty-title-font-size: 16px;
    --empty-list-font-size: 12px;
  }
}


.empty h2 {
  font-weight: 700;
  font-size: var(--empty-title-font-size);
  line-height: 1.4;
  margin: 0 0 var(--empty-margin-size);
  color: var(--gray-900);

}

.empty ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.empty ul li {
  color: var(--gray-700);
  font-size: var(--empty-list-font-size);
  line-height: 1.5;
  font-weight: 400;
}
</style>